import React from 'react'
import CreateExec from './executive/create'
import CreateDesk from './desk/create'
import { getCookie } from "../../utils"
import CONSTANT from "../../constant"

function DakCreate() {
  const user = getCookie(CONSTANT.cookie.userDetail);
  const { designationCode } = user
  return designationCode === 370 ? <CreateDesk /> : <CreateExec /> 
}

export default DakCreate
